import { createQuoteJourneyStore } from "./quoteJourneyStore";
import { parseJourneyPointer } from "./quoteJourneyState";
import {
  JOURNEY_POINTER_KEY,
  type JourneyRepository,
  type JourneyStorage,
} from "./quoteJourneyPersistence";
const operations = new Map<string, Set<Promise<void>>>();
/** finally结束；包含取消后delete的最后回执，不能只登记put请求。 */
export function beginQuoteJourneyOperation(scope: string): () => void {
  const active = operations.get(scope) ?? new Set<Promise<void>>();
  operations.set(scope, active);
  let done!: () => void;
  const pending = new Promise<void>((resolve) => {
    done = resolve;
  });
  active.add(pending);
  return () => {
    if (!active.delete(pending)) return;
    done();
    if (!active.size && operations.get(scope) === active)
      operations.delete(scope);
  };
}
const tabStorage: JourneyStorage = {
  getItem: (key) => window.sessionStorage.getItem(key),
  setItem: (key, value) => window.sessionStorage.setItem(key, value),
  removeItem: (key) => window.sessionStorage.removeItem(key),
};
export async function clearQuoteJourneySession(
  scope: string | null,
  deps: {
    store: Pick<JourneyRepository, "clearScope">;
    storage: JourneyStorage;
  } = { store: createQuoteJourneyStore(), storage: tabStorage },
): Promise<boolean> {
  if (!scope) return true;
  // 调用者已同步卸载来源，不能再开始新保存；等旧操作清理完，随后按scope删除。
  while (operations.get(scope)?.size)
    await Promise.all([...operations.get(scope)!]);
  let cleared = true;
  try {
    await deps.store.clearScope(scope);
  } catch {
    cleared = false;
  }
  try {
    if (parseJourneyPointer(deps.storage.getItem(JOURNEY_POINTER_KEY), scope))
      deps.storage.removeItem(JOURNEY_POINTER_KEY);
  } catch {
    cleared = false;
  }
  return cleared;
}
